module.exports = __webpack_public_path__ + "img/end-header-background-zh.37875327.png";